import { Component, OnInit } from '@angular/core';
import { ModalitesService } from '../core/modalites.service';
import { LibellesService } from '../core/libelles.service';
import { FormulaireService } from './formulaire.service';
import { ModeRenduService } from './mode-rendu/mode-rendu.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'bis-saisie',
  templateUrl: './saisie.component.html',
  styleUrls: ['./saisie.component.css']
})
export class SaisieComponent implements OnInit {
  constructor(
    private modaliteService: ModalitesService,
    private libellesService: LibellesService,
    private formulaireService: FormulaireService,
    public modeRenduService: ModeRenduService,
  ) {
  }

  ngOnInit() {
    // Si les nomenclatures ne sont pas chargées, on les récupère
    if (!this.modaliteService.nomenclaturesChargees()) {
      this.modaliteService.init();
    }

    // Si les libellés ne sont pas chargées, on les récupère
    if (!this.libellesService.libellesCharges()) {
      this.libellesService.init();
    }
  }

  get modificationEnCours(): boolean {
    return this.formulaireService.modificationEnCours;
  }

  public toggleModeRendu(): void {
    this.modeRenduService.modeToggle();
  }
  
  get enTest(): boolean {
    return environment.dev;
  }

}
